// An HTML error page (a proxy's 502 while the server restarts) is no
// message to show: its status text, or its title without the number.
const pageText = (body, statusCode, response) => {
  if (typeof body !== 'string' || !/^\s*</.test(body)) return null
  const title = /<title>([^<]*)<\/title>/i.exec(body)?.[1]?.trim()
  return (
    response?.statusText ||
    title?.replace(new RegExp(`^${statusCode}\\s*`), '') ||
    'error page'
  )
}

export function StatusCodeError(statusCode, body, options, response) {
  this.name = 'StatusCodeError'
  this.statusCode = statusCode
  // the proxy reached no server: most likely a restart
  this.serverUnavailable = [502, 503, 504].includes(statusCode)
  // body: the parsed reply, or null for one without a body
  this.statusText =
    pageText(body, statusCode, response) ??
    (body?.error || body?.errors || body)
  this.details = JSON.stringify(body)
  this.errorData = body?.error || body?.errors
  this.message = this.statusCode + ' - ' + this.statusText
  this.error = body // legacy attribute
  this.options = options
  this.response = response

  if (Error.captureStackTrace) {
    // required for non-V8 environments
    Error.captureStackTrace(this)
  }
}
StatusCodeError.prototype = Object.create(Error.prototype)
StatusCodeError.prototype.constructor = StatusCodeError
